import React, { useEffect, useState } from "react";
import NavigoDashboardUtils from "../services/DigitiseDashboardUtils";
import EventService from "../../../../../service/event/EventService";
import FontIcons from "react-md/lib/FontIcons";
import moment from "moment";
import { SelectField } from "react-md";
import { TextField } from "@material-ui/core";
import { Col, Row } from "react-flexbox-grid";
import { Button, SelectionControlGroup } from "react-md";
import { exit } from "process";
import PatientsService from "../../../../ops/modules/patients/service/PatientsService";
import { Modal } from "@material-ui/core";
import UpdateTrackingService from "../../../../ops/modules/patients/modules/new-bridge/components/Update_tracking/service/UpdateTrackingService";
import CreateServiceUtil from "../../service-module/services/CreateServiceUtil";
import { ContactSupport } from "@material-ui/icons";
import successtick from "../../../../../assets/images/done-animation.gif";
import Autocomplete from "@material-ui/lab/Autocomplete";

function ManageSlots(props) {
  const scrollRef = React.useRef(null);

  const navigoDashboardUtils = new NavigoDashboardUtils();
  const patientService = new PatientsService();
  const updatetrackingservice = new UpdateTrackingService();
  const createServiceUtil = new CreateServiceUtil();
  const [availabilityId, setAvailabilityId] = useState(
    props?.data?.availabilityId || null,
  );

  const isEditMode = Boolean(availabilityId);

  useEffect(() => {
    if (!availabilityId) return;

    fetchExistingAvailability(availabilityId);
  }, [availabilityId]);

  const fetchExistingAvailability = (id) => {
    createServiceUtil.getAllData(
      id,
      (res) => {
        setPageData(res);
        setPageStatus(res.active ? "ACTIVE" : "INACTIVE");
        setSelectedServiceMode(res.mode);
        setSelectedService(res.serviceId);
        const matchedService = serviceOptions.find(
          (s) => s.id === res.serviceId,
        );

        setSelectedServiceObj(matchedService || null);
        setSelectedServiceProvider(res.providerId);
        preserveScroll();
        setRules(
          (res.rules || []).map((r) => ({
            id: r.id,
            selectedDays: Object.keys(r.calendarConfig.weekDays).filter(
              (d) => r.calendarConfig.weekDays[d],
            ),
            daysPerWeek: r.calendarConfig.weekEnabledDaysCount,
            bookingPerSlot: r.calendarConfig.bookingsPerSlot,
            selectedPlans: r.planEntities.map((p) => ({
              ...p,
              status: p.active,
            })),
            autoAddFuturePlans: r.syncPlans.active,
            active: r.active,
            expanded: true,
            createdAt: r.createdAt,
          })),
        );
        const mappedRules = mapApiRulesToUiRules(res.rules);
        preserveScroll();
        setRules(mappedRules);
        // 🔥 Ensure backend rule plans exist in master plans list
        const backendPlans = res.rules.flatMap((r) =>
          (r.planEntities || []).map((p) => ({
            value: p.planId,
            label: `${p.accountCode} - Plan ID ${p.planId}`,
            margin: {
              planId: p.planId,
              accountCode: p.accountCode,
              planStartDate: p.planStartDate,
              planEndDate: p.planEndDate,
              margin: p.margin,
            },
          })),
        );

        setPlans((prevPlans) => {
          const existingIds = prevPlans.map((p) => p.value);

          const missingPlans = backendPlans.filter(
            (p) => !existingIds.includes(p.value),
          );

          return [...prevPlans, ...missingPlans];
        });

        setInitialDataSnapshot({
          pageStatus: res.active ? "ACTIVE" : "INACTIVE",
          serviceId: res.serviceId,
          providerId: res.providerId,
          mode: res.mode,
          rules: mappedRules,
        });

        // 🔥 FETCH CALENDAR
        (res.rules || []).forEach((rule) => {
          fetchCalendarForRule(res, rule.id, moment());
        });

        // 🔥🔥🔥 THIS WAS MISSING
        fetchProviderAvailability(res.serviceId, res.providerId, res.mode);
      },
      (err) => {
        EventService.emit("showError", {
          message: err?.message || "Failed to load availability",
        });
      },
    );
  };

  const [servicesTypeArr, setServicesTypeArr] = useState([]);
  const [servicesTypeObj, setServicesTypeObj] = useState([]);
  const [selectedServiceType, setSelectedServiceType] = useState(null);
  const [serviceModeOptions, setServiceModeOptions] = useState([]);
  const [selectedServiceMode, setSelectedServiceMode] =
    useState("Centre visit");

  const [serviceList, setServiceList] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [selectedServiceObj, setSelectedServiceObj] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedServiceProvider, setSelectedServiceProvider] = useState(null);
  const [selectedProviderObj, setSelectedProviderObj] = useState(null);
  const [assignedServiceProvidersData, setAssignedServiceProvidersData] =
    useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [providerOptions, setProviderOptions] = useState([]);
  const [providerAvailability, setProviderAvailability] = useState(null);
  const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const selectedModeData = selectedServiceProvider?.serviceModes?.find(
    (m) => m.mode === "Centre visit",
  );

  const availableTime = selectedModeData?.availability?.availableTime || [];
  const unavailableTime = selectedModeData?.availability?.unavailableTime || [];
  const [showAvailabilityModal, setShowAvailabilityModal] = useState(false);
  const [showUnavailabilityModal, setShowUnavailabilityModal] = useState(false);

  const [filterStartDate, setFilterStartDate] = useState(null);
  const [filterEndDate, setFilterEndDate] = useState(null);
  const [plans, setPlans] = useState([]);
  const [plansLoading, setPlansLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [pageStatus, setPageStatus] = useState("ACTIVE");
  const [calendarByRule, setCalendarByRule] = useState({});
  const [activeCalendarRule, setActiveCalendarRule] = useState(null);
  const [calendarMonth, setCalendarMonth] = useState(moment());
  const [pageData, setPageData] = useState(null);
  // const [allPlanOptions, setAllPlanOptions] = useState([]);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showRuleInfoModal, setShowRuleInfoModal] = useState(false);
  const [showPlansInfoModal, setShowPlansInfoModal] = useState(false);
  const [l4Exist, setl4exist] = useState(false);
  const [l4Id, setl4Id] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [ruleToDelete, setRuleToDelete] = useState(null);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [initialDataSnapshot, setInitialDataSnapshot] = useState(null);
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [marginData, setMarginData] = useState({});
  const [marginColor, setMarginColor] = useState({});
  const today = moment().format("YYYY-MM-DD");
  const nextMonth = moment().add(1, "month").format("YYYY-MM-DD");

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(nextMonth);

  const [unFromDate, setUnFromDate] = useState(today);
  const [unToDate, setUnToDate] = useState(nextMonth);
  const [showUnDateFilter, setShowUnDateFilter] = useState(false);

  const getFilteredAvailability = () => {
    if (!fromDate || !toDate) return availableDays;

    const from = moment(fromDate, "YYYY-MM-DD").startOf("day");
    const to = moment(toDate, "YYYY-MM-DD").endOf("day");

    return availableDays.filter((item) => {
      const itemDate = moment(item.date, [
        "YYYY-MM-DD",
        "DD/MM/YYYY",
        "DD-MM-YYYY",
        moment.ISO_8601,
      ]);

      if (!itemDate.isValid()) return false;

      return itemDate.isSameOrAfter(from) && itemDate.isSameOrBefore(to);
    });
  };

  const getFilteredUnavailability = () => {
    if (!unFromDate || !unToDate) return unavailableDays;

    const from = moment(unFromDate, "YYYY-MM-DD").startOf("day");
    const to = moment(unToDate, "YYYY-MM-DD").endOf("day");

    return unavailableDays.filter((item) => {
      const itemDate = moment(item.date, [
        "YYYY-MM-DD",
        "DD/MM/YYYY",
        "DD-MM-YYYY",
        moment.ISO_8601,
      ]);

      if (!itemDate.isValid()) return false;

      return itemDate.isSameOrAfter(from) && itemDate.isSameOrBefore(to);
    });
  };

  const PAGE_STATUS_OPTIONS = [
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
  ];

  const createEmptyRule = (enabledDays) => ({
    tempId: Date.now(),
    selectedDays: [...enabledDays],
    active: true,
    daysPerWeek: null,
    bookingPerSlot: null,
    selectedPlans: [],
    autoAddFuturePlans: false,
    expanded: true,
    tempSelectedPlans: [], // ✅ ADD THIS
  });

  const [rules, setRules] = useState([]);
  const WEEK_DAYS = [
    { key: "monday", label: "Mon" },
    { key: "tuesday", label: "Tue" },
    { key: "wednesday", label: "Wed" },
    { key: "thursday", label: "Thu" },
    { key: "friday", label: "Fri" },
    { key: "saturday", label: "Sat" },
    { key: "sunday", label: "Sun" },
  ];
  const schedule = providerAvailability?.schedule || {};
  const enabledDays = WEEK_DAYS.filter((d) => schedule[d.key]?.length > 0).map(
    (d) => d.key,
  );

  const totalAvailableDays = enabledDays.length;

  // const daysPerWeekOptions = Array.from(
  //   { length: totalAvailableDays },
  //   (_, i) => ({
  //     label: `${i + 1} days`,
  //     value: i + 1,
  //   }),
  // );

  const bookingPerSlotMax = providerAvailability?.config?.bookingPerSlot || 0;

  const bookingPerSlotOptions = Array.from(
    { length: bookingPerSlotMax },
    (_, i) => ({
      label: `${i + 1} slots`,
      value: i + 1,
    }),
  );
  const filterByDateRange = (items) => {
    if (!filterStartDate || !filterEndDate) return [];

    return items.filter((item) => {
      const d = moment(item.date);
      return (
        d.isSameOrAfter(moment(filterStartDate), "day") &&
        d.isSameOrBefore(moment(filterEndDate), "day")
      );
    });
  };

  const showAvailabilityActions =
    selectedServiceProvider && assignedServiceProvidersData.length > 0;
  const filteredAvailability = filterByDateRange(availableTime);
  const filteredUnavailability = filterByDateRange(unavailableTime);

  useEffect(() => {
    if (!enabledDays.length) return;
    setRules((prev) => {
      if (prev.length > 0) return prev;

      return [
        {
          tempId: Date.now(),

          selectedDays: [...enabledDays],
          active: true,
          daysPerWeek: null,
          bookingPerSlot: null,
          selectedPlans: [],
          autoAddFuturePlans: false,
          expanded: true,
        },
      ];
    });
  }, [enabledDays]);

  const addRule = () => {
    if (!enabledDays.length) return;
    preserveScroll();
    setRules((prev) => [...prev, createEmptyRule(enabledDays)]);
  };

  const toggleRule = (id) => {
    preserveScroll();
    setRules((prev) =>
      prev.map((rule) =>
        rule.id === id ? { ...rule, expanded: !rule.expanded } : rule,
      ),
    );
  };
  const RuleBox = ({ rule, index, onToggle }) => {
    const globallySelectedPlanIds = rules.flatMap((r) =>
      r.selectedPlans.map((p) => p.planId),
    );

    const validTempSelectedPlans = (rule.tempSelectedPlans || []).filter(
      (id) => !globallySelectedPlanIds.includes(id),
    );

    const availablePlanOptions = plans.filter(
      (plan) => !globallySelectedPlanIds.includes(plan.value),
    );

    const addAllPlansToRule = () => {
      const globallySelectedPlanIds = rules.flatMap((r) =>
        r.selectedPlans.map((p) => p.planId),
      );

      const plansToAdd = plans
        .filter((plan) => !globallySelectedPlanIds.includes(plan.value))
        .map((plan) => ({
          planId: plan.value,
          accountCode: plan.margin.accountCode,
          planStartDate: plan.margin.planStartDate,
          planEndDate: plan.margin.planEndDate,
          margin: plan.margin.margin,
          status: true,
          createdAt: new Date(),
        }));
      preserveScroll();
      setRules((prev) =>
        prev.map((r) =>
          (r.id || r.tempId) === (rule.id || rule.tempId)
            ? {
                ...r,
                selectedPlans: [...r.selectedPlans, ...plansToAdd],
              }
            : r,
        ),
      );
    };

    const allPlanIds = plans.map((p) => p.value);
    const selectedPlanIds = rule.selectedPlans.map((p) => p.planId);

    const isAllPlansAdded =
      allPlanIds.length > 0 &&
      allPlanIds.every((id) => rule.selectedPlans.some((p) => p.planId === id));
    const removeAllPlansFromRule = () => {
      setRules((prev) =>
        prev.map((r) =>
          (r.id || r.tempId) === (rule.id || rule.tempId)
            ? { ...r, selectedPlans: [] }
            : r,
        ),
      );
    };

    const totalSelectedDays = rule.selectedDays.length;

    const daysPerWeekOptions = Array.from(
      { length: totalSelectedDays },
      (_, i) => ({
        label: `${i + 1} days`,
        value: i + 1,
      }),
    );
    const hasSelectedPlans = rule.selectedPlans.length > 0;

    return (
      <div className="rule-box">
        <div className="rule-header">
          <div className="rule-header-left">
            <span className="rule-title-text">
              Customize service provider availability - Rule {index + 1}
            </span>

            <span
              className="info-dot"
              onClick={(e) => {
                e.stopPropagation();
                setShowRuleInfoModal(true);
              }}
            >
              i
            </span>
          </div>

          <div className="rule-header-right">
            {rule.createdAt && (
              <span className="rule-created-date">
                Creation date:{" "}
                {moment
                  .utc(rule.createdAt)
                  .local()
                  .format("DD MMM YYYY, HH:mm")}
              </span>
            )}
            {!rule.id && (
              <FontIcons
                className="rule-delete-icon"
                onClick={(e) => {
                  e.stopPropagation();
                  setRuleToDelete(rule.id || rule.tempId);
                  setShowDeleteModal(true);
                }}
              >
                delete
              </FontIcons>
            )}

            <label className="switch">
              <input
                type="checkbox"
                checked={rule.active}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setRules((prev) =>
                    prev.map((r) =>
                      (r.id || r.tempId) === (rule.id || rule.tempId)
                        ? { ...r, active: checked }
                        : r,
                    ),
                  );
                }}
              />
              <span className="slider round" />
            </label>
            <FontIcons
              className="rule-collapse-icon"
              onClick={(e) => {
                e.stopPropagation();
                setRules((prev) =>
                  prev.map((r) =>
                    (r.id || r.tempId) === (rule.id || rule.tempId)
                      ? { ...r, expanded: !r.expanded }
                      : r,
                  ),
                );
              }}
            >
              {rule.expanded ? "expand_less" : "expand_more"}
            </FontIcons>
          </div>
        </div>

        {/* BODY */}
        {rule.expanded && (
          <>
            {/* ================= RULE BODY ================= */}
            <div
              className={`rule-body ${!rule.active ? "rule-disabled" : ""}`}
              style={{
                pointerEvents: rule.active ? "auto" : "none",
                opacity: rule.active ? 1 : 0.4,
              }}
            >
              <label className="field-label">
                Available days per week
                <label className="mp-label-red"> *</label>
              </label>

              <div className="days-container">
                {WEEK_DAYS.map((day) => {
                  const isEnabled = enabledDays.includes(day.key);
                  const isSelected = rule.selectedDays.includes(day.key);

                  return (
                    <button
                      key={day.key}
                      type="button"
                      disabled={!isEnabled}
                      className={`day-pill
                ${!isEnabled ? "disabled" : ""}
                ${isEnabled && isSelected ? "selected" : ""}
                ${isEnabled && !isSelected ? "unselected" : ""}
              `}
                      onClick={() => {
                        if (!isEnabled) return;

                        setRules((prev) =>
                          prev.map((r) => {
                            if ((r.id || r.tempId) !== (rule.id || rule.tempId))
                              return r;

                            const updatedSelectedDays = isSelected
                              ? r.selectedDays.filter((d) => d !== day.key)
                              : [...r.selectedDays, day.key];

                            const maxAllowed = updatedSelectedDays.length;

                            return {
                              ...r,
                              selectedDays: updatedSelectedDays,
                              daysPerWeek:
                                r.daysPerWeek > maxAllowed
                                  ? maxAllowed
                                  : r.daysPerWeek,
                            };
                          }),
                        );
                      }}
                    >
                      {day.label}
                    </button>
                  );
                })}
              </div>

              {pageData?.rules?.some(
                (r) => (r.id || r.tempId) === (rule.id || rule.tempId),
              ) && (
                <button
                  type="button"
                  className="view-calendar-btn"
                  onClick={() => {
                    const month = moment();
                    setActiveCalendarRule(rule.id);
                    setCalendarMonth(month);
                    fetchCalendarForRule(pageData, rule.id, month);
                  }}
                >
                  View calendar
                </button>
              )}

              <div className="rule-row">
                <div className="rule-col">
                  <SelectField
                    label={
                      <span>
                        Days per week<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    menuItems={daysPerWeekOptions}
                    value={
                      rule.daysPerWeek > totalSelectedDays
                        ? totalSelectedDays
                        : rule.daysPerWeek
                    }
                    fullWidth
                    disabled={totalSelectedDays === 0}
                    onChange={(v) =>
                      setRules((prev) =>
                        prev.map((r) =>
                          (r.id || r.tempId) === (rule.id || rule.tempId)
                            ? { ...r, daysPerWeek: v }
                            : r,
                        ),
                      )
                    }
                  />
                </div>

                <div className="rule-col">
                  <SelectField
                    label={
                      <span>
                        Booking per slot<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    menuItems={bookingPerSlotOptions}
                    value={rule.bookingPerSlot}
                    fullWidth
                    onChange={(v) =>
                      setRules((prev) =>
                        prev.map((r) =>
                          (r.id || r.tempId) === (rule.id || rule.tempId)
                            ? { ...r, bookingPerSlot: v }
                            : r,
                        ),
                      )
                    }
                  />
                </div>
              </div>

              {/* ================= PLANS SECTION ================= */}
              <div className="plans-section">
                <div className="plans-row">
                  <div className="plans-dropdown">
                    <Autocomplete
                      multiple
                      options={availablePlanOptions}
                      getOptionLabel={(option) => option.label || ""}
                      value={availablePlanOptions.filter((opt) =>
                        (rule.tempSelectedPlans || []).includes(opt.value),
                      )}
                      onChange={(event, newValue) =>
                        setRules((prev) =>
                          prev.map((r) =>
                            (r.id || r.tempId) === (rule.id || rule.tempId)
                              ? {
                                  ...r,
                                  tempSelectedPlans: newValue.map(
                                    (v) => v.value,
                                  ),
                                }
                              : r,
                          ),
                        )
                      }
                      disabled={
                        plansLoading || availablePlanOptions.length === 0
                      }
                      filterSelectedOptions
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={
                            <span>
                              Plan(s)<span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          placeholder={
                            plansLoading ? "Loading plans..." : "Select plans"
                          }
                          variant="standard"
                        />
                      )}
                    />
                  </div>
                  <div className="plans-actions">
                    {/* ADD BUTTON */}
                    <Button
                      className="btn-add"
                      disabled={validTempSelectedPlans.length === 0}
                      onClick={() => {
                        const plansToAdd = validTempSelectedPlans
                          .map((id) => {
                            const plan = plans.find((p) => p.value === id);
                            if (!plan) return null;

                            return {
                              planId: plan.value,
                              accountCode: plan.margin.accountCode,
                              planStartDate: plan.margin.planStartDate,
                              planEndDate: plan.margin.planEndDate,
                              margin: plan.margin.margin,
                              status: true,
                              createdAt: new Date(),
                            };
                          })
                          .filter(Boolean);

                        if (!plansToAdd.length) return;

                        setRules((prev) =>
                          prev.map((r) =>
                            (r.id || r.tempId) === (rule.id || rule.tempId)
                              ? {
                                  ...r,
                                  selectedPlans: [
                                    ...r.selectedPlans,
                                    ...plansToAdd,
                                  ],
                                  tempSelectedPlans: [],
                                }
                              : r,
                          ),
                        );
                      }}
                    >
                      Add
                    </Button>

                    {/* ADD ALL BUTTON */}
                    <Button
                      className="btn-add-all"
                      disabled={availablePlanOptions.length === 0}
                      onClick={addAllPlansToRule}
                    >
                      Add all plans
                    </Button>

                    {/* REMOVE ALL BUTTON */}
                    <Button
                      className="btn-remove-all"
                      disabled={!hasSelectedPlans}
                      onClick={removeAllPlansFromRule}
                    >
                      Remove all plans
                    </Button>
                  </div>
                </div>

                <div className="plans-checkbox-row">
                  <label className="auto-add-checkbox">
                    <input
                      type="checkbox"
                      checked={rule.autoAddFuturePlans}
                      disabled={
                        autoAddEnabledRuleId && autoAddEnabledRuleId !== rule.id
                      }
                      onChange={() =>
                        setRules((prev) =>
                          prev.map((r) =>
                            (r.id || r.tempId) === (rule.id || rule.tempId)
                              ? {
                                  ...r,
                                  autoAddFuturePlans: !r.autoAddFuturePlans,
                                }
                              : { ...r, autoAddFuturePlans: false },
                          ),
                        )
                      }
                    />
                    Automatically add all the future plans where this service is
                    assigned
                  </label>
                </div>
              </div>
            </div>

            {/* ================= PLANS TABLE (COLLAPSIBLE + DISABLED) ================= */}
            {rule.selectedPlans.length > 0 && (
              <div
                className="plans-table-container"
                style={{
                  pointerEvents: rule.active ? "auto" : "none",
                  opacity: rule.active ? 1 : 0.4,
                }}
              >
                <div className="plans-table-header">
                  <h4 className="plans-table-title">
                    Service provider availability is customized on below listed
                    plans
                    <span
                      className="plans-info-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowPlansInfoModal(true);
                      }}
                    >
                      i
                    </span>
                  </h4>
                </div>

                <table className="plans-table">
                  <thead>
                    <tr>
                      <th>Account code</th>
                      <th>Plan ID</th>
                      <th>Plan start date</th>
                      <th>Plan end date</th>
                      <th>Date</th>
                      <th>Margin</th>
                      <th>Status</th>
                      <th>Remove</th>
                    </tr>
                  </thead>

                  <tbody>
                    {rule.selectedPlans.map((p) => (
                      <tr key={p.planId}>
                        <td>{p.accountCode}</td>
                        <td>{p.planId}</td>
                        <td>
                          {moment.utc(p.planStartDate).format("DD MMM YYYY")}
                        </td>
                        <td>
                          {moment.utc(p.planEndDate).format("DD MMM YYYY")}
                        </td>
                        <td>
                          {moment(p.createdAt).format("DD MMM YYYY, HH:mm")}
                        </td>
                        <td>
                          <span
                            className="margin-pill"
                            style={{
                              background: p.margin.colour,
                              color: "#FFFFF",
                            }}
                          >
                            {p.margin.name}
                          </span>
                        </td>

                        <td>
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={p.status}
                              disabled={!rule.active}
                              onChange={() =>
                                setRules((prev) =>
                                  prev.map((r) =>
                                    (r.id || r.tempId) ===
                                    (rule.id || rule.tempId)
                                      ? {
                                          ...r,
                                          selectedPlans: r.selectedPlans.map(
                                            (sp) =>
                                              sp.planId === p.planId
                                                ? { ...sp, status: !sp.status }
                                                : sp,
                                          ),
                                        }
                                      : r,
                                  ),
                                )
                              }
                            />
                            <span className="slider round" />
                          </label>
                        </td>

                        <td>
                          <FontIcons
                            className="delete-icon"
                            onClick={() => {
                              if (!rule.active) return;

                              setRules((prev) =>
                                prev.map((r) =>
                                  (r.id || r.tempId) ===
                                  (rule.id || rule.tempId)
                                    ? {
                                        ...r,
                                        selectedPlans: r.selectedPlans.filter(
                                          (sp) => sp.planId !== p.planId,
                                        ),
                                      }
                                    : r,
                                ),
                              );
                            }}
                          >
                            delete
                          </FontIcons>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </>
        )}
      </div>
    );
  };

  const exitPage = () => {
    props.setView(0);
  };

  useEffect(() => {
    setSelectedServiceMode("Centre visit");
  }, []);

  useEffect(() => {
    if (!assignedServiceProvidersData.length) {
      setProviderOptions([]);
      return;
    }

    const options = assignedServiceProvidersData
      // only providers that support selected mode
      .filter((p) =>
        p.serviceModes?.some(
          (m) => m.mode === selectedServiceMode && m.enabled,
        ),
      )
      .map((p) => ({
        label: `(${p.serviceProviderId}) ${p.serviceProviderName} (${p.serviceProviderCity || "NA"})`,
        value: p.serviceProviderId,
      }));

    setProviderOptions(options);
  }, [assignedServiceProvidersData, selectedServiceMode]);

  useEffect(() => {
    if (!selectedService || !selectedServiceMode) return;

    getAssignedServiceProvidersDataByFilter({
      serviceIds: [selectedService],
      serviceProviderIds: [],
      mode: selectedServiceMode,
    });
  }, [selectedService, selectedServiceMode]);

  useEffect(() => {
    getMarginData();
    getMarginColor();
  }, []);

  const getMarginData = () => {
    let onResponse = (res) => {
      setMarginData(res);
    };

    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching margin L3 data`,
      });
    };
    createServiceUtil.getMarginData(onResponse, onError);
  };
  const getMarginColor = () => {
    let onResponse = (res) => {
      setMarginColor(res);
    };

    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching margin L3 data`,
      });
    };
    createServiceUtil.getMarginColor(onResponse, onError);
  };

  const getMergedMarginRules = () => {
    if (!marginData || !marginColor) return [];

    const bands = marginColor?.bands || [];
    const restrictionBands =
      marginData?.modeConfig?.find((m) => m.mode === "Centre visit")
        ?.restrictionBands || [];

    return restrictionBands.map((rule) => {
      const bandMeta = bands.find((b) => b.band === rule.bandId);

      return {
        bandId: rule.bandId,
        name: bandMeta?.name || "Unknown",
        colour: bandMeta?.colour || "#ccc",
        daysPerWeek: rule.weekEnabledDaysCount,
        bookingsPerSlot: rule.bookingsPerSlot,
      };
    });
  };
  const mergedMargins = getMergedMarginRules();

  const getAssignedServiceProvidersDataByFilter = (body) => {
    let onResponse = (res) => {
      const providers = res?.assignedServiceProviders ?? [];

      setTotalCount(res?.totalCount ?? 0);
      setAssignedServiceProvidersData(providers);

      if (!providers.length) {
        setProviderOptions([]);
        setSelectedServiceProvider(null);

        EventService.emit("showError", {
          message:
            "No service providers available for this service on this mode",
        });
      }
    };

    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error in fetching assigned service providers: ${err?.message}`,
      });
    };

    createServiceUtil.getAssignedServiceProvidersByFilter(
      body,
      onResponse,
      onError,
    );
  };

  useEffect(() => {
    getServiceType();
  }, []);

  const getServiceType = () => {
    let onResponse = (res) => {
      setServicesTypeArr(res || []);

      // ✅ Auto select Health checkup (id = 2)
      const defaultServiceType = (res || []).find((item) => item.id === 2);

      if (defaultServiceType) {
        setSelectedServiceType(defaultServiceType);

        // ✅ Set service modes
        if (defaultServiceType?.modes?.length) {
          setServiceModeOptions(
            defaultServiceType.modes.map((m) => ({
              label: m,
              value: m,
            })),
          );
        }

        // ✅ Fetch services immediately
        getServicesByServiceType(defaultServiceType.id);
      }
    };

    let onError = (err) => {
      EventService.emit("showError", {
        message: `Error: ${err?.message}`,
      });
    };

    createServiceUtil.getServiceType(true, onResponse, onError);
  };

  useEffect(() => {
    let dropdownObj = servicesTypeArr.map((e) => {
      return {
        label: e.name,
        value: e.id,
      };
    });
    setServicesTypeObj(dropdownObj);
  }, [servicesTypeArr]);

  // useEffect(() => {
  //   if (!selectedService || !selectedServiceMode) return;

  //   getAssignedServiceProvidersDataByFilter({
  //     serviceIds: [selectedService],
  //     serviceProviderIds: [],
  //     mode: selectedServiceMode,
  //   });
  // }, [selectedService, selectedServiceMode]);

  const getServicesByServiceType = (serviceTypeId) => {
    if (!serviceTypeId) return;

    const payload = {
      pageNum: 0,
      pageSize: 0,
      serviceTypeIds: [serviceTypeId],
    };

    createServiceUtil.getServicesByFilter(
      payload,
      (res) => {
        if (res?.services?.length) {
          const services = res?.services || [];
          setServiceOptions(services);
        } else {
          setServiceList([]);
          setServiceOptions([]);
        }
      },
      (err) => {
        EventService.emit("showError", {
          message: err?.message || "Failed to fetch services",
        });
        setServiceOptions([]);
      },
    );
  };

  useEffect(() => {
    if (!selectedService || !selectedServiceProvider || !selectedServiceMode)
      return;

    fetchPlans({
      serviceId: selectedService,
      providerId: selectedServiceProvider,
      mode: selectedServiceMode,
    });
  }, [selectedService, selectedServiceProvider, selectedServiceMode]);
  const fetchPlans = ({ serviceId, providerId, mode }) => {
    setPlansLoading(true);

    const payload = { serviceId, providerId, mode };

    createServiceUtil.getAllPlans(
      payload,
      (res) => {
        const apiPlans =
          res?.marginPlanEntities?.map((p) => ({
            value: p.planId,
            label: `${p.accountCode} - Plan ID ${p.planId}`,
            margin: p,
          })) || [];

        setPlans((prevPlans) => {
          const existingIds = prevPlans.map((p) => p.value);

          const merged = [...prevPlans];

          apiPlans.forEach((p) => {
            if (!existingIds.includes(p.value)) {
              merged.push(p);
            }
          });

          return merged;
        });

        if (!isEditMode && res?.l4Exists) {
          setl4exist(true);
          setl4Id(res?.l4Id);

          EventService.emit("showError", {
            message: "Combination already exists.",
          });

          setProviderAvailability(null);
          setRules([]);

          setPlansLoading(false);
          return;
        }

        setl4exist(false);

        setPlansLoading(false);
      },
      (err) => {
        EventService.emit("showError", {
          message: err?.message || "Failed to fetch plans",
        });
        setPlansLoading(false);
      },
    );
  };

  const buildSavePayload = () => {
    return {
      id: isEditMode ? availabilityId : undefined,
      serviceId: selectedService,
      providerId: selectedServiceProvider,
      mode: selectedServiceMode,
      active: pageStatus === "ACTIVE",

      rules: rules.map((rule) => {
        const ALL_DAYS = [
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
          "sunday",
        ];
        const schedule = providerAvailability?.schedule || {};

        const weekDaysObj = ALL_DAYS.reduce((acc, day) => {
          const isEnabled = schedule[day]?.length > 0;
          const isSelected = rule.selectedDays.includes(day);

          acc[day] = isEnabled && isSelected; // 🔥 FIX
          return acc;
        }, {});

        return {
          ...(rule.id ? { id: rule.id } : {}), // only backend id

          active: rule.active,

          calendarConfig: {
            weekEnabledDaysCount: rule.daysPerWeek,
            bookingsPerSlot: rule.bookingPerSlot,
            weekDays: weekDaysObj,
          },

          planEntities: rule.selectedPlans.map((p) => ({
            planId: p.planId,
            active: rule.active ? p.status : false,
          })),

          syncPlans: {
            active: rule.autoAddFuturePlans,
          },
        };
      }),
    };
  };
  useEffect(() => {
    if (!serviceOptions.length || !selectedService) return;

    const matchedService = serviceOptions.find((s) => s.id === selectedService);

    setSelectedServiceObj(matchedService || null);
  }, [serviceOptions, selectedService]);

  const previousScroll = React.useRef(0);

  useEffect(() => {
    if (!scrollRef.current) return;

    scrollRef.current.scrollTop = previousScroll.current;
  }, [rules]);

  const preserveScroll = () => {
    if (!scrollRef.current) return;
    previousScroll.current = scrollRef.current.scrollTop;
  };

  const handleSave = () => {
    const payload = buildSavePayload();

    const onSuccess = (res) => {
      EventService.emit("showSuccess", {
        message: isEditMode
          ? "Service provider availability updated successfully"
          : "Service provider availability saved successfully",
      });

      setSuccessModal(true);

      const idToFetch = availabilityId || res?.id;

      if (idToFetch) {
        setAvailabilityId(idToFetch);
        fetchExistingAvailability(idToFetch);
      }
    };

    const onError = (err) => {
      EventService.emit("showError", {
        message: err?.message || "Something went wrong",
      });
    };

    if (availabilityId) {
      createServiceUtil.updateServiceProviderAvailability(
        payload,
        onSuccess,
        onError,
      );
    } else {
      createServiceUtil.saveServiceProviderAvailability(
        payload,
        onSuccess,
        onError,
      );
    }
  };

  const resetServiceDependentState = () => {
    setSelectedServiceProvider(null);
    setProviderAvailability(null);
    setPlans([]);
    setRules([]);
    setShowAvailabilityModal(false);
    setShowUnavailabilityModal(false);
  };

  const fetchData = (id) => {
    createServiceUtil.getAllData(id, (res) => {
      console.log("dddd", res.id);
      setPageData(res);
      setPageStatus(res.active ? "ACTIVE" : "INACTIVE");
      availabilityId = res.id;
      setSelectedService(res.serviceId);
      setSelectedServiceProvider(res.providerId);
      setSelectedServiceMode(res.mode);

      // ✅ SET RULES FROM API
      const mappedRules = mapApiRulesToUiRules(res.rules);

      setRules(mappedRules);

      setInitialDataSnapshot({
        pageStatus: res.active ? "ACTIVE" : "INACTIVE",
        serviceId: res.serviceId,
        providerId: res.providerId,
        mode: res.mode,
        rules: mappedRules,
      });

      fetchProviderAvailability(res.serviceId, res.providerId, res.mode);
    });
  };
  const mapApiRulesToUiRules = (apiRules = []) => {
    return apiRules.map((r) => ({
      id: r.id,
      selectedDays: Object.keys(r.calendarConfig.weekDays).filter(
        (d) => r.calendarConfig.weekDays[d],
      ),
      daysPerWeek: r.calendarConfig.weekEnabledDaysCount,
      bookingPerSlot: r.calendarConfig.bookingsPerSlot,
      selectedPlans: r.planEntities.map((p) => ({
        ...p,
        status: p.active,
      })),
      autoAddFuturePlans: r.syncPlans.active,
      active: r.active,
      expanded: true,
      createdAt: r.createdAt,
    }));
  };

  const fetchProviderAvailability = (serviceId, providerId, mode) => {
    createServiceUtil.getAssignedServiceProvidersByFilter(
      {
        serviceIds: [serviceId],
        serviceProviderIds: [providerId],
        mode,
      },
      (res) => {
        const provider = res?.assignedServiceProviders?.[0];
        const selectedMode = provider?.serviceModes?.find(
          (m) => m.mode === mode,
        );

        setProviderAvailability(selectedMode?.availability || null);
      },
      (err) => {
        EventService.emit("showError", {
          message: "Failed to load provider availability",
        });
      },
    );
  };

  const fetchCalendarForRule = (pageRes, ruleId, monthMoment) => {
    if (!pageRes || !ruleId || !monthMoment) return;

    const payload = {
      serviceId: pageRes.serviceId,
      providerId: pageRes.providerId,
      mode: pageRes.mode,
      ruleId,
      year: monthMoment.year(),
      month: monthMoment.month() + 1,
    };

    createServiceUtil.getCalendar(
      payload,
      (res) => {
        setCalendarByRule((prev) => ({
          ...prev,
          [ruleId]: res,
        }));
      },
      (err) => {
        EventService.emit("showError", {
          message: err?.message || "Failed to get calendar",
        });
      },
    );
  };

  const availableDays = providerAvailability?.availableTime || [];
  const unavailableDays = providerAvailability?.unavailableTime || [];

  const renderCalendarGrid = (calendarRes, monthMoment) => {
    if (!calendarRes?.calendarDays) return null;

    const dayTypeMap = new Map(
      calendarRes.calendarDays.map((d) => [d.date, d.dayType]),
    );

    const start = monthMoment.clone().startOf("month");
    while (start.isoWeekday() !== 1) {
      start.subtract(1, "day");
    }

    const end = monthMoment.clone().endOf("month");
    while (end.isoWeekday() !== 7) {
      end.add(1, "day");
    }

    const days = [];
    let d = start.clone();
    while (d.isSameOrBefore(end)) {
      days.push(d.clone());
      d.add(1, "day");
    }

    const todayStr = moment().format("YYYY-MM-DD");

    return (
      <>
        <div className="calendar-weekdays">
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((w) => (
            <div key={w} className="calendar-weekday">
              {w}
            </div>
          ))}
        </div>

        <div className="calendar-grid">
          {days.map((day) => {
            const dateStr = day.format("YYYY-MM-DD");
            const dayType = dayTypeMap.get(dateStr);
            const isToday = dateStr === todayStr;
            const isCurrentMonth = day.month() === monthMoment.month();

            return (
              <div
                key={dateStr}
                className={`calendar-day
                ${dayType === 1 ? "available" : ""}
                ${dayType === 2 ? "disabled" : ""}
                ${!isCurrentMonth ? "muted" : ""}
                ${isToday ? "today" : ""}
              `}
              >
                {day.date()}
              </div>
            );
          })}
        </div>
      </>
    );
  };

  useEffect(() => {
    // Only in create mode
    if (isEditMode) return;

    // Wait until required data exists
    if (!selectedService || !selectedServiceProvider || !providerAvailability)
      return;

    // Only set once
    setInitialDataSnapshot((prev) => {
      if (prev) return prev;

      return {
        pageStatus,
        serviceId: selectedService,
        providerId: selectedServiceProvider,
        mode: selectedServiceMode,
        rules,
      };
    });
  }, [
    isEditMode,
    selectedService,
    selectedServiceProvider,
    providerAvailability,
  ]);

  const hasUnsavedChanges = () => {
    if (!initialDataSnapshot) return false;

    const currentData = {
      pageStatus,
      serviceId: selectedService,
      providerId: selectedServiceProvider,
      mode: selectedServiceMode,
      rules,
    };

    return JSON.stringify(initialDataSnapshot) !== JSON.stringify(currentData);
  };

  const activeRuleIndex = rules.findIndex((r) => r.id === activeCalendarRule);
  const autoAddEnabledRuleId = rules.find(
    (r) => r.autoAddFuturePlans === true,
  )?.id;

  useEffect(() => {
    if (isEditMode && pageData) {
      fetchProviderAvailability(
        pageData.serviceId,
        pageData.providerId,
        pageData.mode,
      );
    }
  }, [isEditMode, pageData]);

  const isFormValid = () => {
    // Top level validation
    if (!selectedService) return false;
    if (!selectedServiceProvider) return false;
    if (!rules.length) return false;

    // Rule-level validation
    for (let rule of rules) {
      if (!rule.selectedDays || rule.selectedDays.length === 0) return false;
      if (!rule.daysPerWeek) return false;
      if (!rule.bookingPerSlot) return false;
      if (!rule.selectedPlans || rule.selectedPlans.length === 0) return false;
    }

    return true;
  };

  const resetProviderDependentState = () => {
    setProviderAvailability(null);
    setPlans([]);
    setRules([]);
    setCalendarByRule({});
    setActiveCalendarRule(null);

    setShowAvailabilityModal(false);
    setShowUnavailabilityModal(false);

    setFromDate(today);
    setToDate(nextMonth);
    setUnFromDate(today);
    setUnToDate(nextMonth);

    setInitialDataSnapshot(null);
    setl4exist(false);
  };

  const openExistingAvailability = () => {
    if (!l4Id) return;

    setl4exist(false);
    setAvailabilityId(l4Id);
  };

  return (
    <>
      <div style={{ marginLeft: "18px", marginBottom: "24px" }}>
        {" "}
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className="navigo-module-view">
              <div className="navigo-module-heading-with-back-button">
                <div className="navigo-module-back-btn">
                  <FontIcons
                    style={{
                      fontSize: "36px",
                      marginTop: "2px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      if (hasUnsavedChanges()) {
                        setShowBackModal(true);
                      } else {
                        exitPage();
                      }
                    }}
                  >
                    arrow_back
                  </FontIcons>
                </div>
                <h1>{`Service Provider Availability (Level 4)`}</h1>
              </div>

              <div className="navigo-module-buttons-container">
                <div className="page-status-wrapper">
                  <SelectField
                    id="page-status"
                    menuItems={PAGE_STATUS_OPTIONS}
                    value={pageStatus}
                    onChange={setPageStatus}
                    className={`page-status-select ${
                      pageStatus === "ACTIVE"
                        ? "status-active"
                        : "status-inactive"
                    }`}
                    position={SelectField.Positions.BELOW}
                    simplified
                    fullWidth={false}
                  />
                </div>
                <div className="navigo-module-buttons-right-alignment">
                  <Button
                    raised
                    className={`navigo-module-button-save-enabled ${
                      !isFormValid() || l4Exist ? "btn-grey-disabled" : ""
                    }`}
                    onClick={handleSave}
                    disabled={!isFormValid() || l4Exist}
                  >
                    {isEditMode ? "Update" : "Save"}
                  </Button>

                  <Button
                    raised
                    className="navigo-module-button-save-enabled"
                    onClick={() => setShowCancelModal(true)}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div style={{ marginLeft: "24px" }}>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-create-service-field-container">
            <div className="mp-label">
              {`Service type`}
              <label className="mp-label-red"> *</label>
            </div>
            <SelectField
              placeholder="Select"
              className="mp-select-field no-dropdown-icon"
              menuItems={servicesTypeObj}
              value={selectedServiceType?.id || ""}
              disabled
            />
          </div>
        </Col>
        <Col xs={12} sm={3} md={3} lg={3}>
          <div className="mp-create-service-field-container">
            <div className="mp-label">
              {`Service mode`}
              <label className="mp-label-red"> *</label>
            </div>
            <div>
              <SelectField
                placeholder="Select"
                className="mp-select-field no-dropdown-icon"
                menuItems={[{ label: "Centre visit", value: "Centre visit" }]}
                value="Centre visit"
                disabled
              />
            </div>
          </div>
        </Col>
        <div className="figma-autocomplete-scope">
          {" "}
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-create-service-field-container">
              <div className="mp-label" style={{ marginBottom: "1px" }}>
                {`Service`}
                <label className="mp-label-red"> *</label>
              </div>
              <div>
                <Autocomplete
                  openOnFocus
                  options={serviceOptions || []}
                  getOptionLabel={(option) =>
                    option
                      ? `(${option.id}) ${option.name} - ${option.serviceName}`
                      : ""
                  }
                  disabled={isEditMode}
                  value={selectedServiceObj}
                  onChange={(e, newValue) => {
                    resetServiceDependentState();
                    setSelectedServiceObj(newValue);
                    setSelectedService(newValue ? newValue.id : null);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      placeholder="Type and Select service"
                      InputProps={{
                        ...params.InputProps,
                        disableUnderline: false,
                      }}
                      className="custom-autocomplete-field"
                    />
                  )}
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={3} md={3} lg={3}>
            <div className="mp-create-service-field-container">
              <div
                className="mp-label"
                style={{ marginTop: "4px", marginBottom: "1px" }}
              >
                {`Service provider`}
                <label className="mp-label-red"> *</label>
              </div>
              <div>
                <Autocomplete
                  openOnFocus
                  options={providerOptions || []}
                  getOptionLabel={(option) => option?.label || ""}
                  value={
                    providerOptions.find(
                      (opt) => opt.value === selectedServiceProvider,
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disabled={
                    isEditMode ||
                    !selectedService ||
                    providerOptions.length === 0
                  }
                  className={`provider-autocomplete ${
                    isEditMode ||
                    !selectedService ||
                    providerOptions.length === 0
                      ? "disabled-autocomplete"
                      : ""
                  }`}
                  filterOptions={(options, state) =>
                    options.filter((option) =>
                      option.label
                        .toLowerCase()
                        .includes(state.inputValue.toLowerCase()),
                    )
                  }
                  onChange={(e, newValue) => {
                    // 🔥 Reset everything first
                    resetProviderDependentState();

                    setSelectedProviderObj(newValue);
                    setSelectedServiceProvider(
                      newValue ? newValue.value : null,
                    );

                    if (!newValue) return;

                    setAvailabilityLoading(true);

                    setTimeout(() => {
                      const provider = assignedServiceProvidersData.find(
                        (p) => p.serviceProviderId === newValue.value,
                      );

                      const centreVisitMode = provider?.serviceModes?.find(
                        (m) => m.mode === "Centre visit",
                      );

                      setProviderAvailability(
                        centreVisitMode?.availability || null,
                      );

                      setAvailabilityLoading(false);
                    }, 500);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      placeholder="Type and Select provider"
                      className="custom-autocomplete-field provider-field"
                    />
                  )}
                />
              </div>
            </div>
          </Col>
        </div>
        {availabilityLoading && (
          <div style={{ marginTop: "24px" }}>
            <FontIcons className="md-spin">autorenew</FontIcons>
            <span style={{ marginLeft: 8 }}>Loading availability…</span>
          </div>
        )}
        {l4Exist && (
          <div
            className="l4-next-link-container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "100%",
            }}
          >
            <a
              href="#"
              className="l4-next-link"
              onClick={(e) => {
                e.preventDefault();
                openExistingAvailability();
              }}
              style={{
                fontSize: "16px",
                color: "#97144D",
                textDecoration: "underline",
                cursor: "pointer",
              }}
            >
              Click here to open existing availability
            </a>
          </div>
        )}
        {!l4Exist && providerAvailability && !availabilityLoading && (
          <div
            className="availability-container"
            style={{
              marginTop: "24px",
              marginRight: "18px",
            }}
          >
            <div className="availability-header">
              <h3 className="availability-title">
                Service provider “master weekly schedule” for this service as
                defined on level 2
              </h3>

              <span
                className="info-icon"
                onClick={() => setShowInfoModal(true)}
              >
                i
              </span>
            </div>

            {Object.entries(providerAvailability.schedule).map(
              ([day, slots]) => {
                const isDisabled = !slots || slots.length === 0;

                return (
                  <div
                    key={day}
                    className={`availability-row ${isDisabled ? "disabled-day" : ""}`}
                  >
                    <div className="availability-day">
                      {day.charAt(0).toUpperCase() + day.slice(1)}
                    </div>

                    <div className="availability-slots">
                      {!isDisabled &&
                        slots.map((s, i) => (
                          <span key={i} className="slot">
                            {s.start} - {s.end}
                          </span>
                        ))}
                    </div>
                  </div>
                );
              },
            )}

            <div className="availability-config">
              <div className="availability-config-item">
                <label>Duration (mins)</label>
                <div className="availability-value">
                  {providerAvailability.config.slotDurationInMinutes}
                </div>
              </div>

              <div className="availability-config-item">
                <label>Booking per slot</label>
                <div className="availability-value">
                  {providerAvailability.config.bookingPerSlot}
                </div>
              </div>

              <div className="availability-config-item">
                <label>Min booking notice (days)</label>
                <div className="availability-value">
                  {providerAvailability.config.minBookingDays}
                </div>
              </div>

              <div className="availability-config-item">
                <label>Max advance booking (days)</label>
                <div className="availability-value">
                  {providerAvailability.config.maxAdvBookingDays}
                </div>
              </div>
            </div>
          </div>
        )}
        {showAvailabilityActions && !availabilityLoading && !l4Exist && (
          <div className="availability-actions">
            <Button
              flat
              className="availability-pill-btn"
              onClick={() => {
                setFilterStartDate(null);
                setFilterEndDate(null);
                setShowAvailabilityModal(true);
              }}
            >
              Availability beyond master weekly schedule
            </Button>

            <Button
              flat
              className="availability-pill-btn"
              onClick={() => {
                setFilterStartDate(null);
                setFilterEndDate(null);
                setShowUnavailabilityModal(true);
              }}
            >
              Unavailability beyond master weekly schedule
            </Button>
          </div>
        )}
        {showAvailabilityActions && !availabilityLoading && !l4Exist && (
          <div className="margin-rules-container">
            <h3
              className="margin-rules-title"
              style={{
                wordBreak: "break-word",
                overflowWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              Level 4a Slot restriction rules (This is applicable for service
              provider where more than 1 Service provider is active on that
              city+service+mode)
            </h3>

            <div className="margin-grid">
              <div className="grid-header">Margin</div>
              <div className="grid-header">Days per week</div>

              {mergedMargins.map((item, index) => (
                <React.Fragment key={index}>
                  <div>
                    <span
                      className="margin-pill"
                      style={{ background: item.colour }}
                    >
                      {item.name}
                    </span>
                  </div>

                  <div className="margin-value">{item.daysPerWeek}</div>
                </React.Fragment>
              ))}
            </div>
          </div>
        )}

        <Modal
          open={showAvailabilityModal}
          onClose={() => setShowAvailabilityModal(false)}
        >
          <div className="availability-modal">
            <div className="modal-header">
              <h2>
                Service provider availability beyond master weekly schedule
              </h2>
              <span
                className="close-btn"
                onClick={() => setShowAvailabilityModal(false)}
              >
                ×
              </span>
            </div>

            <div className="table">
              <div className="table-header">
                <div className="date-header-container">
                  <div className="date-top-row">
                    <span className="date-label">Date</span>

                    <span
                      className="filter-icon"
                      onClick={() => setShowDateFilter(!showDateFilter)}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path d="M3 5h18l-7 8v6l-4-2v-4L3 5z" fill="#444" />
                      </svg>
                    </span>
                  </div>

                  <div className="date-range-text">
                    {moment(fromDate).format("DD MMM YYYY")} -{" "}
                    {moment(toDate).format("DD MMM YYYY")}
                  </div>
                </div>

                <span>Availability</span>
              </div>
              {showDateFilter && (
                <div className="date-filter-box">
                  <div className="date-field">
                    <label>From</label>
                    <div className="date-input-wrapper">
                      <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="date-field">
                    <label>To</label>
                    <div className="date-input-wrapper">
                      <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div
                    className="clear-filter"
                    onClick={() => {
                      setShowDateFilter(false);
                    }}
                  >
                    ×
                  </div>
                </div>
              )}

              {getFilteredAvailability().length === 0 ? (
                <div className="empty-state">No availability defined</div>
              ) : (
                getFilteredAvailability().map((item) => (
                  <div key={item.date} className="table-row">
                    <span>{moment(item.date).format("DD MMM YYYY")}</span>
                    <span>
                      {item.slots.map((s, i) => (
                        <span key={i}>
                          {s.start} - {s.end}
                          {i < item.slots.length - 1 && ", "}
                        </span>
                      ))}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </Modal>

        <Modal
          open={showUnavailabilityModal}
          onClose={() => setShowUnavailabilityModal(false)}
        >
          <div className="availability-modal">
            <div className="modal-header">
              <h2>
                Service provider unavailability beyond master weekly schedule
              </h2>
              <span
                className="close-btn"
                onClick={() => setShowUnavailabilityModal(false)}
              >
                ×
              </span>
            </div>

            <div className="table">
              <div className="table-header">
                <div className="date-header-container">
                  <div className="date-top-row">
                    <span className="date-label">Date</span>

                    <span
                      className="filter-icon"
                      onClick={() => setShowUnDateFilter(!showUnDateFilter)}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path d="M3 5h18l-7 8v6l-4-2v-4L3 5z" fill="#444" />
                      </svg>
                    </span>
                  </div>

                  <div className="date-range-text">
                    {moment(unFromDate).format("DD MMM YYYY")} -{" "}
                    {moment(unToDate).format("DD MMM YYYY")}
                  </div>
                </div>

                <span>Non availability</span>
              </div>

              {showUnDateFilter && (
                <div className="date-filter-box">
                  <div className="date-field">
                    <label>From</label>
                    <div className="date-input-wrapper">
                      <input
                        type="date"
                        value={unFromDate}
                        onChange={(e) => setUnFromDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="date-field">
                    <label>To</label>
                    <div className="date-input-wrapper">
                      <input
                        type="date"
                        value={unToDate}
                        onChange={(e) => setUnToDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div
                    className="clear-filter"
                    onClick={() => {
                      setShowUnDateFilter(false);
                    }}
                  >
                    ×
                  </div>
                </div>
              )}

              {getFilteredUnavailability().length === 0 ? (
                <div className="empty-state">No unavailability defined</div>
              ) : (
                getFilteredUnavailability().map((item) => (
                  <div key={item.date} className="table-row">
                    <span>{moment(item.date).format("DD MMM YYYY")}</span>
                    <span>
                      {item.slots.map((s, i) => (
                        <span key={i}>
                          {s.start} - {s.end}
                          {i < item.slots.length - 1 && ", "}
                        </span>
                      ))}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        </Modal>

        {!l4Exist &&
          providerAvailability &&
          showAvailabilityActions &&
          !availabilityLoading && (
            <div ref={scrollRef}>
              {rules.map((rule, index) => (
                <RuleBox
                  key={rule.id || rule.tempId}
                  rule={rule}
                  index={index}
                  onToggle={toggleRule}
                />
              ))}

              <div className="add-more" onClick={addRule}>
                + Add more
              </div>
            </div>
          )}
      </div>
      <Modal open={successModal}>
        <div className="success-modal">
          <div className="success-icon-wrapper">
            <img
              className="success-img"
              src={successtick}
              alt="success-tick"
            ></img>
          </div>

          <h2 className="success-title">
            {isEditMode
              ? "Rules updated successfully!"
              : "Rules saved successfully!"}
          </h2>

          <Button
            raised
            className="success-done-btn"
            onClick={() => {
              setSuccessModal(false);
            }}
          >
            Done
          </Button>
        </div>
      </Modal>
      <Modal
        open={!!activeCalendarRule}
        onClose={() => setActiveCalendarRule(null)}
      >
        <div className="calendar-modal-wrapper">
          <div className="calendar-modal">
            <div className="modal-header">
              <h2>
                Service provider availability calendar : Rule{" "}
                {activeRuleIndex >= 0 ? activeRuleIndex + 1 : ""}
              </h2>
              <span
                className="close-btn"
                onClick={() => setActiveCalendarRule(null)}
              >
                ×
              </span>
            </div>

            <div className="calendar-nav">
              <button
                onClick={() => {
                  const prev = calendarMonth.clone().subtract(1, "month");
                  setCalendarMonth(prev);
                  fetchCalendarForRule(pageData, activeCalendarRule, prev);
                }}
              >
                ‹
              </button>

              <strong>{calendarMonth.format("MMMM YYYY")}</strong>

              <button
                onClick={() => {
                  const next = calendarMonth.clone().add(1, "month");
                  setCalendarMonth(next);
                  fetchCalendarForRule(pageData, activeCalendarRule, next);
                }}
              >
                ›
              </button>
            </div>

            {renderCalendarGrid(
              calendarByRule[activeCalendarRule],
              calendarMonth,
            )}
          </div>
        </div>
      </Modal>

      <Modal open={showInfoModal} onClose={() => setShowInfoModal(false)}>
        <div className="info-modal">
          <div className="info-modal-header">
            <h2>
              Service provider “master weekly schedule” for this service as
              defined on level 2
            </h2>

            <span className="close-btn" onClick={() => setShowInfoModal(false)}>
              ×
            </span>
          </div>

          <div className="info-modal-content">
            <p>
              This section displays the availability and booking constraints for
              a service provider as configured at Level 2.
            </p>

            <h4>Schedule Components</h4>
            <ul>
              <li>
                <b>Weekly Time Slots:</b> A day-by-day breakdown showing the
                specific hours the provider is available (as created at level
                2).
              </li>
              <li>
                <b>Duration (mins):</b> The fixed length of time allocated for a
                single slot under this service.
              </li>
              <li>
                <b>Booking per slot:</b> The maximum number of bookings allowed
                within any single slot (time window).
              </li>
              <li>
                <b>Min booking notice (days):</b> The minimum amount of time
                required for a user to book an appointment.(e.g., "2 days"
                notice ensures no last-minute bookings).
              </li>
              <li>
                <b>Max advance booking (days):</b> How far into the future a
                user can view and book the provider’s schedule.(e.g., "25 days"
                means the slots can be booked only within the next three weeks).
              </li>
            </ul>

            <h4>Overrides & Exceptions</h4>
            <ul>
              <li>
                <b>Availability beyond master weekly schedule:</b> View specific
                dates or times where the provider is available outside recurring
                hours (e.g., a one-time Sunday clinic), as added on level 2.
              </li>
              <li>
                <b>Unavailability beyond master weekly schedule:</b> View
                specific dates where the provider is unavailable despite the
                recurring schedule (e.g., public holidays or unavailability of
                SP), as added on level 2.
              </li>
            </ul>
          </div>
        </div>
      </Modal>
      <Modal
        open={showRuleInfoModal}
        onClose={() => setShowRuleInfoModal(false)}
      >
        <div className="rule-info-modal">
          <div className="rule-info-modal-header">
            <h2>What is ‘Customize service provider availability’?</h2>
            <span
              className="rule-info-close"
              onClick={() => setShowRuleInfoModal(false)}
            >
              ×
            </span>
          </div>

          <div className="rule-info-modal-body">
            <p>
              This section allows you to define rules for how service provider
              slots will be visible to users of selected plans/accounts.
            </p>

            <h4>Rule Configuration</h4>

            <ul>
              <li>
                <b>Available days per week:</b> Specific days of the week (e.g.,
                Mon–Sat) when the service provider is available for bookings on
                L2.
              </li>
            </ul>

            {/* DAY LEGEND */}
            <div className="rule-info-day-legend">
              <div className="day-box selected">Mon</div>
              <div className="day-label">
                <b>Selected day</b>
                <span>Slots will be available</span>
              </div>

              <div className="day-box deselected">Mon</div>
              <div className="day-label">
                <b>Deselected day</b>
                <span>Slots will be restricted</span>
              </div>

              <div className="day-box disabled">Mon</div>
              <div className="day-label">
                <b>Unavailable day in L2</b>
              </div>
            </div>

            <ul>
              <li>
                <b>Days per week:</b> Total number of days within a week on
                which slots will be available. The system will randomly pick
                from the selected days.
              </li>

              <li>
                <b>Booking per slot:</b> Maximum number of slots visible to the
                user.
              </li>

              <li>
                <b>Plan(s):</b> Specific plans to which this availability rule
                applies.
              </li>

              <li>
                <b>Add all plans:</b> Quickly include every existing plan.
              </li>

              <li>
                <b>Automatically add all future plans:</b> Any future plan with
                this service will automatically inherit this rule.
              </li>
            </ul>
          </div>
        </div>
      </Modal>
      <Modal
        open={showPlansInfoModal}
        onClose={() => setShowPlansInfoModal(false)}
      >
        <div className="plans-info-modal-overlay">
          <div className="plans-info-modal">
            <div className="plans-info-modal-header">
              <h2>
                What is ‘Service provider availability customized on below
                listed plans’?
              </h2>
              <span
                className="plans-info-close"
                onClick={() => setShowPlansInfoModal(false)}
              >
                ×
              </span>
            </div>

            <div className="plans-info-modal-body">
              <p>
                This table provides a comprehensive overview of all selected
                plans that are added for the availability and slot restriction
                rules defined above.
              </p>

              <h4>Table Columns & Actions</h4>

              <ul>
                <li>
                  <b>Plan Details:</b> View the <b>Account code</b>,{" "}
                  <b>Plan ID</b>, and the specific <b>Start and End dates</b>{" "}
                  for each plan added to this rule.
                </li>

                <li>
                  <b>Date:</b> Refers to the timestamp when the plan was
                  successfully added to rule.
                </li>

                <li>
                  <b>Margin:</b> Indicates the monetary benefits (e.g., Very
                  low, Low, Medium) from the provider assigned within that plan.
                </li>

                <li>
                  <b>Status Toggle:</b>
                  <ul>
                    <li>
                      <b>Enabled (Green):</b> The rules are actively restricting
                      the provider’s availability for this plan.
                    </li>
                    <li>
                      <b>Disabled (Red):</b> The rules are paused for this plan,
                      reverting the provider to default availability.
                    </li>
                  </ul>
                </li>

                <li>
                  <b>Remove (Bin Icon):</b> Permanently deletes the rule
                  customization from that specific plan. Once removed, the
                  provider’s availability will revert to default availability.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Modal>
      <Modal open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
        <div className="delete-rule-modal-wrapper">
          <div className="delete-rule-modal">
            <h3>Delete rule</h3>
            <p>
              Are you sure you want to <b>delete this rule</b>? You will lose
              all the data filled in this rule.
            </p>

            <div className="modal-actions">
              <Button
                className="btn-delete-confirm"
                onClick={() => {
                  if (rules.length <= 1) {
                    setShowDeleteModal(false);
                    setRuleToDelete(null);

                    EventService.emit("showError", {
                      message: "Minimum one rule is compulsory.",
                    });

                    return;
                  }

                  setRules((prev) =>
                    prev.filter((r) => (r.id || r.tempId) !== ruleToDelete),
                  );

                  setShowDeleteModal(false);
                  setRuleToDelete(null);
                }}
              >
                Yes
              </Button>
              <Button
                className="btn-delete-cancel"
                onClick={() => {
                  setShowDeleteModal(false);
                  setRuleToDelete(null);
                }}
              >
                No
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal open={showBackModal} onClose={() => setShowBackModal(false)}>
        <div className="back-modal-wrapper">
          <div className="back-modal">
            <h2>Are you sure you want to go back?</h2>
            <p>Any unsaved changes will be lost</p>

            <div className="back-modal-actions">
              <Button
                className="btn-keep-editing"
                onClick={() => setShowBackModal(false)}
              >
                Keep editing
              </Button>

              <Button
                className="btn-go-back"
                onClick={() => {
                  setShowBackModal(false);
                  exitPage();
                }}
              >
                Go back
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      <Modal open={showCancelModal} onClose={() => setShowCancelModal(false)}>
        <div className="cancel-modal-wrapper">
          <div className="cancel-modal">
            <h2>Are you sure you want to cancel?</h2>
            <p>Any unsaved changes will be lost</p>

            <div className="cancel-modal-actions">
              <Button
                className="btn-confirm-cancel"
                onClick={() => {
                  setShowCancelModal(false);
                  props.setView(0); // your original cancel action
                }}
              >
                Yes
              </Button>

              <Button
                className="btn-cancel-no"
                onClick={() => setShowCancelModal(false)}
              >
                No
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ManageSlots;
